import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Toaster } from 'sonner';
import { applyColorTheme, getColorTheme } from '@/lib/theme';

// Apply the saved color theme before first paint to avoid a flash.
applyColorTheme(getColorTheme());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Toaster position="top-right" richColors />
  </React.StrictMode>,
);
